export const ADMIN_EMAILS = [
  'tozkusaksiz@gmail.com',
  'tansel@rapider.ai',
  'canmustu@rapider.ai',
];

export const ADMIN_PHONES = [
  '+13472559099'
]